import type { TReaderDocument } from '@app-evolution-cms/email-builder';

import { ColorPicker } from '../../../../primitives/color-picker';
import { Separator } from '../../../../primitives/separator';
import { LabelWithoutRef } from '../../../label/label-without-ref';
import { EMAIL_COLORS } from '../constants/colors';
import { Appearance } from './container/appearance';

type EmailLayoutData = Extract<TReaderDocument[string], { type: 'EmailLayout' }>['data'];

type GlobalStylesEditorContentProps = {
  data: EmailLayoutData;
  onChange: (updates: Partial<EmailLayoutData>) => void;
};

export function GlobalStylesEditorContent({ data, onChange }: GlobalStylesEditorContentProps) {
  return (
    <div className="grid gap-4">
      <p className="text-sm font-medium">Estilos globales</p>

      <div>
        <LabelWithoutRef className="text-xs font-medium text-muted-foreground">
          Fondo
        </LabelWithoutRef>
        <ColorPicker
          colors={EMAIL_COLORS}
          isCleanColorVisible
          noneColorLabel="Sin personalizar"
          value={data.backdropColor ?? ''}
          onValueChange={(value) => onChange({ backdropColor: value ?? null })}
        />
      </div>

      <Separator />

      <section aria-label="Lienzo">
        <Appearance
          complementaryLabel="del lienzo"
          backgroundColor={data.canvasColor ?? ''}
          borderColor={data.borderColor ?? ''}
          borderRadius={data.borderRadius}
          borderStyle={data.borderStyle}
          borderWidths={data.borderWidths}
          onBorderStyleChange={(borderStyle) => onChange({ borderStyle })}
          onBorderWidthsChange={(borderWidths) => onChange({ borderWidths })}
          onBackgroundColorChange={(value) => onChange({ canvasColor: value ?? null })}
          onBorderColorChange={(borderColor, settings) => onChange({ borderColor, ...settings })}
          onBorderRadiusChange={(value) => onChange({ borderRadius: value ?? null })}
        />
      </section>
    </div>
  );
}
